import "./Hr.scss";

const Hr = function () {
  return <hr className="hr" />;
};

export default Hr;
